import React, { useState } from "react";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function VISAiX() {
  const [selectedFeature, setSelectedFeature] = useState("applicants");

  const features = {
    applicants: [
      "AI-Powered Eligibility Checker",
      "Smart Document Upload & Verification",
      "Real-Time Tracking",
      "Appointment Scheduling & Reminders",
      "AI-Powered Mock Interviews",
      "24/7 Chatbot Support",
    ],
    businesses: [
      "Bulk Visa Processing",
      "Fast-Track Processing",
      "Automated Compliance Checks",
      "Integrated Document Management",
    ],
    agents: [
      "Multi-Client Dashboard",
      "Automated Reminders & Follow-ups",
      "AI-Based Risk Analysis",
      "Agent Performance Analytics",
    ],
    government: [
      "AI-Powered Fraud Detection",
      "Automated Data Entry & Verification",
      "Integration with National Databases",
      "Data-Driven Decision Making",
    ],
  };

  return (
    <div className="min-h-screen bg-gray-500 text-gray-900">
      <header className="bg-blue-600 text-white py-6 px-8 shadow-lg">
        <h1 className="text-3xl font-bold">VISAiX - Powered by Think5Whys</h1>
        <p className="flex justify-center mt-2 text-lg">Revolutionizing Visa Processing with AI</p>
      </header>
      <main className="max-w-7xl mx-auto py-12 px-6">
        <section className="text-center mb-12">
          <h2 className="text-2xl font-bold mb-4">Why Choose VISAiX?</h2>
          <p className="text-yellow-200 max-w-3xl mx-auto">
            VISAiX simplifies and automates visa processing with AI-driven insights, fraud detection, and predictive approval estimations.
          </p>
        </section>
        <section className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-4 text-blue-700">Visa Process Steps</h3>
            <ul className="list-disc pl-6 text-gray-700">
              <li>User Registration & Profile Setup</li>
              <li>Visa Selection & Requirements Analysis</li>
              <li>Application Form Submission</li>
              <li>Document Upload & Verification</li>
              <li>Fee Payment & Appointment Scheduling</li>
              <li>Biometric & Interview Process</li>
              <li>Application Tracking & Real-time Updates</li>
              <li>Visa Approval & Collection</li>
              <li>Post-Visa Services</li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-4 text-blue-700">Who We Serve</h3>
            <div className="flex space-x-4 mb-4">
              {Object.keys(features).map((key) => (
                <button
                  key={key}
                  className={`px-4 py-2 rounded-lg font-semibold transition ${
                    selectedFeature === key ? "bg-blue-600 text-white" : "bg-gray-500"
                  }`}
                  onClick={() => setSelectedFeature(key)}
                >
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </button>
              ))}
            </div>
            <ul className="list-none text-gray-700 transition-opacity duration-500 ease-in-out opacity-100">
              {features[selectedFeature].map((feature, index) => (
                <li key={index} className="flex items-center space-x-2 mb-2 animate-fadeIn">
                  <FontAwesomeIcon icon={faCheckCircle} className="text-blue-600" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </main>
      <footer className="bg-gray-900 text-white py-6 text-center">
        <p>&copy; 2025 VISAiX. All rights reserved.</p>
      </footer>
    </div>
  );
}
